import Vue from "vue";
import VTooltip from 'v-tooltip';
import RegisterWidget from "./components/RegisterWidget/RegisterWidget.vue";
import store from './store/index';

Vue.config.productionTip = false;

Vue.use(VTooltip, {
    defaultTrigger: 'focus, hover, click',
    defaultBoundariesElement: 'window',
    defaultPlacement: 'right',
    defaultClass: 'vuw-tooltip',
    defaultTemplate: '<div class="" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
})

let RegisterWidgets = document.querySelectorAll('widget-register');
if (RegisterWidgets.length) {
    RegisterWidgets.forEach(el => {
        new Vue({
            el: el,
            store,
            render(h) {
                let language = this.$el.attributes.getNamedItem('language');
                let captchaKey = this.$el.attributes.getNamedItem('captcha-key');

                return h(RegisterWidget, {
                    props: {
                        configRaw: {
                            language: language ? language.value : null,
                            captchaKey: captchaKey ? captchaKey.value : null
                        }
                    }
                });
            }
        });
    });
}
